import { render, staticRenderFns } from "./TransferBadge.vue?vue&type=template&id=2c62d8b0"
import script from "./TransferBadge.vue?vue&type=script&lang=js"
export * from "./TransferBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports